import React from 'react';
import ReactDOM from 'react-dom';
import {components} from "../Components/BusinessCard";
import rootReducer from '../app/RootReducer';
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import '../app/styles.css';
import '@brainhubeu/react-carousel/lib/style.css';

const {BusinessCardContainer} = components;

function isRunningOnServerSide(){
    return (typeof window === "undefined");
}

function isRunningOnClientSide(){
    return (typeof window !== "undefined");
}

function initState(state){
    if(isRunningOnServerSide()){
        return state;
    }
    else if(isRunningOnClientSide()){
        return Object.assign({},state,{app:{ url: window.location.href }});
    }
}

const rootElement = document.getElementById("root");

const initialState = window.__INITIAL_STATE;
const state = initState(initialState);
delete window.__INITIAL_STATE;

const store = createStore(rootReducer,state);

ReactDOM.hydrate(
    <Provider store={store}>
        <BusinessCardContainer/>
    </Provider>
, rootElement);

    

